import "./App.css";

const CatchError = () => {
  return <p className="error">Wystąpił błąd. Spróbuj później...</p>;
};

export default CatchError;
